import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=16fe4e94&scoped=true&"
import script from "./Grades.vue?vue&type=script&lang=js&"
export * from "./Grades.vue?vue&type=script&lang=js&"
import style0 from "./Grades.vue?vue&type=style&index=0&id=16fe4e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe4e94",
  null
  
)

export default component.exports